import React from "react";
import Card from "./Card";

const Keno = () => {
  return (
    <Card
      categoryKey="keno"
      allowedTypeKeys={["keno"]}
      categoryCode="KENO"
      categoryLabel="หวย/คีโน่"
      categoryBlockedMessage="ท่านไม่สามารถเล่นประเภทเกมส์หวย/คีโน่ได้ เนื่องจากติดเงื่อนไข"
    />
  );
};

export default Keno;
